import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { FaEdit, FaTrash } from "react-icons/fa";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import useScrollbarSize from "react-scrollbar-size";
import { Button, Card, ToggleSwitch, Loading, NoRecords } from "../../../components";
import { staticTranslate } from "../../../features/translate/translateSlice";
import Logouts from "../../../components/logout"; 

const keyAuth = global.config.typecode[9] + global.config.authBearerKey;
const keyAuth2 = global.config.typecode[3] + global.config.authBearerKey;
const headersParams = global.config.headersparam;

const TrainingList = () => {
  const translate = useSelector(staticTranslate)
  const chooseLang = useSelector((state) => state.translate.lang)
  const navigate = useNavigate();
  const { height } = useScrollbarSize();
  const [isChecked, setChecked] = useState([]);
  const [pending, setPending] = useState(true);
  const [listTraining, setListTraining] = useState([]);
  const [listDistributor, setListDistributor] = useState([]);
  const [filterData, setFilterData] = useState({statid:"",distributorid:"",countryid:"",rowpage:0});
  const [defRowPage, setDefRowPage] = useState(0);
  const paramsLoc = useLocation();
  if(paramsLoc.state !== null) { var { dataref } = paramsLoc.state; }

  const handleRowsPerPageChange = (val) => {
    setFilterData({ ...filterData, rowpage: val });
    setDefRowPage(val);
  }
  const handleDelete = (id) => {
    if (window.confirm(`${translate.training.alert_delete}`)) {
      document.getElementById("loading-screen").style.display = "flex";
      var fetchUrl = global.config.urlLink + "/deletetraining/" + id;
      headersParams.Authorization = keyAuth;
      fetch(fetchUrl, {
        method: "GET",
        headers: headersParams,
      })
        .then((res) => {
          if (res.status === 200) return res.json();
        })
        .then((res) => {
          if (res.status === "200") {
            document.getElementById("loading-screen").style.display = "none";
            window.location.href = "/training";
          }
        });
    }
  };

  const updtlistStat = (row) => {
    let checkarr = {};
    row.forEach((records) => {
      checkarr[records.training_id] = records.status;
    });
    setChecked(checkarr);
  };

  const handleToggle = (id, stat) => {
    let statcheck = 1,
      statsend = true;
    if (stat === 1) {
      statcheck = 0;
      statsend = false;
    } else {
      statcheck = 1;
      statsend = true;
    }
    setChecked((prevState) => ({ ...prevState, [id]: statcheck }));
    let datatext =
      '{"doc_id":"' +
      id +
      '","status": "' +
      statsend +
      '","lang": "' +
      chooseLang +
      '","from_id":"edit-status-training"}';

    let data = JSON.parse(datatext);
    let fetchUrl = global.config.urlLink + "/edittraining";
    headersParams.Authorization = keyAuth;
    fetch(fetchUrl, {
      method: "POST",
      headers: headersParams,
      body: JSON.stringify(data),
    })
      .then((res) => {
        if (res.status === 200) return res.json();
      })
      .then((resJson) => {
        return false;
      })
      .catch((err) => {
        return false;
      });
  };
  const handleSelect = async (e) => {
    document.getElementById("loading-screen").style.display = "flex";
    var name = e.target.name;
    var value = e.target.value;
    var result1a;
    if(name === "distributorid") {
      result1a = await listTrainingData(filterData.statid,value,filterData.countryid);
    } else if(name === "statid") {
      result1a = await listTrainingData(value,filterData.distributorid,filterData.countryid);
    }
    setListTraining(result1a);
    setFilterData({ ...filterData, [name]: value });
    document.getElementById("loading-screen").style.display = "none";
  }
  const handleDetailClick = (resList,type) => {
    navigate("/training/detail", {
      state: { data: resList, type: type, filter: filterData },
    })
  }
  const loadDistributor = (country) => {
    return new Promise(resolve => {
      if(localStorage.getItem("dulv")===global.config.conflevel[0] || localStorage.getItem("dulv")===global.config.conflevel[1] || localStorage.getItem("dulv")===global.config.conflevel[2]) {
        var datatext ='{';
        datatext += '"from_id":"list-distributor","stat_id":1';
        datatext += ',"lang": "'+chooseLang+'"';
        if(country !== "") { datatext += ',"country_id":"'+country+'"'; }
        datatext += '}';
        var data = JSON.parse(datatext); 
        headersParams.Authorization = keyAuth2;
        
        fetch(global.config.urlLink+"/listdist", {
          method: 'POST',
          headers: headersParams, 
          body : JSON.stringify(data)
        }).then(res => {
            if(res.status === 200) 
                return res.json() 
        }).then( resJson => {
            if(resJson.status === "200") {
              resolve(resJson.values);
            } else {
              resolve([]);
            }
        }).catch((err) => {
            resolve([]);
        });
      } else { resolve([]); }
    });
  }
  const listTrainingData = (stat,distributor,country) => {
    return new Promise(resolve => {
      var fetchUrl = global.config.urlLink + "/listtraining";
      var dataText = '{';
      dataText += '"from_id": "list-training"';
      dataText += ',"lang": "'+chooseLang+'"';
      if(stat !== "") { dataText += ',"stat_id":'+parseInt(stat); }
      if(distributor !== "") { dataText += ',"dist_id":"'+distributor+'"'; }
      if(country !== "") { dataText += ',"country_id":"'+country+'"'; }
      dataText += '}';

      let data = JSON.parse(dataText);
      headersParams.Authorization = keyAuth;
      fetch(fetchUrl, {
        method: "POST",
        headers: headersParams,
        body: JSON.stringify(data),
      }).then((res) => {
          if (res.status === 200) return res.json();
      }).then((res) => {
          if (res.status === "200") {
            resolve(res.values);
          } else if(res.status === global.config.errcodesess) {
            resolve([res.status]);
          } else { resolve([])}
      }).catch((err) => {
        resolve([]);
      });
    });
  };
  const loadData = async () => {
    var idDist = "", idCntry="", idStat="", idRowPage=defRowPage;
    if(localStorage.getItem("dulv")===global.config.conflevel[3]) { idDist = localStorage.getItem("dudst"); idStat = 1; } 
    else if(localStorage.getItem("dulv")===global.config.conflevel[2]) { idCntry = localStorage.getItem("ducr"); }

    if(dataref !== undefined) { idDist = dataref.distributorid; idCntry=dataref.countryid; idStat=dataref.statid; idRowPage=dataref.rowpage; }
    else { idRowPage = 10; }

    let [result1, result2] = await Promise.all([listTrainingData(idStat,idDist,idCntry), loadDistributor(idCntry)]);
    if(result1.length > 0 && result1[0] === global.config.errcodesess) {
      var resultSO = await Logouts();
      if(resultSO.status === "200") {
        window.location.reload();
      }
    } else {
      setPending(false); 
      updtlistStat(result1);
      setListTraining(result1);
      setListDistributor(result2);
      // setFilterData({ ...filterData, distributorid: idDist, countryid: idCntry });
      setFilterData({statid:idStat, distributorid: idDist, countryid: idCntry, rowpage: idRowPage});
      setDefRowPage(idRowPage);
    }
  }

  var optDistributor = [];
  if(listDistributor !== undefined) {
    for(var c=0; c<listDistributor.length; c++) {
      optDistributor.push(<option value={listDistributor[c].distributor_id} key={listDistributor[c].distributor_id}>{listDistributor[c].distributor_name}</option>)
    }
  }

  const ActionCols = (row) => (
    <div className="flex flex-1 gap-4 hover:fill-red-500">
      {/* <FaInfo 
        onClick={() => handleDetailClick(row,"detail")}
        className="hover:fill-red-500 cursor-pointer fasize"
      /> */}
      {(localStorage.getItem("dulv")===global.config.conflevel[0] || localStorage.getItem("dulv")===global.config.conflevel[1] || localStorage.getItem("dulv")===global.config.conflevel[2])?
        <>
        <FaEdit 
          onClick={() => handleDetailClick(row,"edit")}
          className="hover:fill-red-500 cursor-pointer fasize"
        />
        <FaTrash
          onClick={() => handleDelete(row.training_id)}
          className="hover:fill-red-500 cursor-pointer fasize"
        />
        </>
      : //(localStorage.getItem("dulv")===global.config.conflevel[3] && localStorage.getItem("dutk") === row.created_by)?
        <><FaEdit 
          onClick={() => handleDetailClick(row,"edit")}
          className="hover:fill-red-500 cursor-pointer fasize"
        /></>
      //: <></>
      }
    </div>
  );

  const StatusCols = (row) => (
    <div className="flex gap-x-10 items-center">
      {(row.status === true || row.status === 1)? global.config.generalstatus[0] : global.config.generalstatus[1] }
      {/* <ToggleSwitch
        id={row.training_id}
        checked={isChecked[row.training_id] || ""}
        onClick={() => handleToggle(row.training_id, isChecked[row.training_id])}
      /> */}
    </div>
  );

  const column = [
    { name: translate.training.column_1, selector: (row) => row.training_name },
    // { name: "Training URL", 
    //   selector: (row) => (
    //     <Link
    //       to={`//${row.training_link}`}
    //       target={"_blank"}
    //       rel="noopener noreferrer"
    //       className="text-blue-500 underline"
    //     >
    //       Link
    //     </Link>
    //   ),
    // }
  ];
  if(localStorage.getItem("dulv")!==global.config.conflevel[3]) {
    column.push({ name: translate.training.column_3, selector: (row) => row.distributor_name });
    column.push({ name: translate.general.column_status, grow: 0, cell: StatusCols });
  }
  column.push({ name: translate.general.column_action, cell: ActionCols,  width: "120px"  });
  
  
  useEffect(() => {
    loadData();
  }, []);

  return (
    <div className="flex-1 p-8 h-screen bg-gray-100 overflow-y-auto">
      <div className="flex items-center mb-8">
        <h2 className="text-2xl">{translate.training.title}</h2>
        <Button
          variant="icon"
          icon="plus"
          className="ml-5" 
          onClick={() => handleDetailClick(filterData.distributorid,"create")}
        />
        
      </div>
      {(localStorage.getItem("dulv")!==global.config.conflevel[3])?
      <>
      <div className="bg-white shadow-3xl flex flex-1 p-4 gap-x-4 rounded-lg mb-2">
        <p className=" text-gray-400 font-bold">{translate.general.filter}: </p>
        <select name="statid" id="statid" className="bg-white text-gray-400 outline-none" defaultValue=""
          value={filterData.statid} 
          onChange={handleSelect}
        >
          <option value="">{translate.general.filter_status}</option>
          <option value="1">{global.config.generalstatus[0]}</option>
          <option value="0">{global.config.generalstatus[1]}</option>
        </select>
        <select name="distributorid" id="distributorid" className="bg-white text-gray-400 outline-none" defaultValue=""
            value={filterData.distributorid} 
            onChange={handleSelect}
            
          >
            <option value="">{translate.general.filter_distributor}</option>
            {optDistributor}
        </select>
      </div>
      </> : <></>
      }
      <Card className={"h-auto w-auto"}>
      {(defRowPage > 0) && <DataTable
          columns={column}
          data={listTraining}
          fixedHeader
          highlightOnHover
          defaultSortFieldId="id"
          progressPending={pending}
          progressComponent={<Loading className="h-10 w-10 mt-10 mb-10"/>}
          pointerOnHover
          pagination
          paginationPerPage={defRowPage}
          paginationRowsPerPageOptions={[10, 25, 50, 75, 100]}
          onRowClicked={(row) => handleDetailClick(row,"detail")}
          noDataComponent={<NoRecords />}
          onChangeRowsPerPage={handleRowsPerPageChange}
          customStyles={{
            headRow: {
              style: {
                borderBottomWidth: "3px",
                borderBottomStyle: "solid",
                fontWeight: "bold",
                backgroundColor: "#F5F6FA",
                color: "#8A92A6",
              },
              denseStyle: {
                minHeight: "32px",
              },
            },
            table: {
              style: {
                height: `calc(100vh - 180px - ${height}px)`,
              },
            },
          }}
        />
      }
      </Card>
    </div>
  );
};

export default TrainingList;
